  
import CustomPalette from './CustomPalette';
import CustomContextPad from './CustomContextPad';

export default {
  __init__: ['customPalette', 'customContextPad' ],
  customPalette: [ 'type', CustomPalette ],
  customContextPad: ['type', CustomContextPad]
};